import React, { useState } from 'react'
import MessageIcon from '../../Common/svg/messageicon'
import EditPen from '../../Common/svg/editpenicon'
import StatusBadge from '../../UI/statusBadge'
import { useMutation, useQueryClient } from 'react-query'
import { updateOrders } from '../../../MyApi/orders'
import { toast } from 'react-toastify'
import { updateStore } from '../../../MyApi/stores'
import { Spinner } from 'reactstrap'
import { Link } from 'react-router-dom'



const StoreStatusCard = ({categories,name,logo,is_closed ,id ,refetch}) => {
  const [isClosed,setIsClosed]=useState(0)
  const queryClient =useQueryClient()
    const mutation =useMutation({mutationKey:["updateStoreStatus"],mutationFn:(postData)=>updateStore(postData,id),onSuccess:(data)=>{
        toast.success(`${data.message}`)
        refetch()
        queryClient.invalidateQueries("stores")
    }})
    const handleChangeStatus =(e)=>{
        const checked =e.target.checked
        const formData = new FormData()
     setIsClosed(checked)
     formData.append("store[is_closed]",checked ?0:1)
      formData.append("_method","PUT")
        mutation.mutate(formData)
    }
  return (
   <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center gap-3">
              <div className="avatar">
                <img
                  className="media rounded-circle img-80 "   
                  src={logo}
                  alt={name}
                />
              </div>
              <div>
                <div className="d-flex  align-items-center  gap-3">
                  <h5>{name}</h5>
                  <StatusBadge
                    status={!is_closed ? "active" : ""}
                    statusLabel={!is_closed ? "متاح الان" : "غير متاح"}
                  />
                </div>
                <h4 className="desc store mw-50  font16 mt-3">{categories}</h4>
              </div>
            </div>
            <div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <Link className="btn btn-white" to={`${process.env.PUBLIC_URL}/stores/edit/${id}`}>
                  <EditPen />
                </Link>
                {/* <button className="btn btn-white">
                  <MessageIcon />
                </button> */}
              </div>
              <div className="d-flex align-items-center mt-2 gap-2">
                <label htmlFor="">{is_closed ?"المطعم غير متاح":"المطعم متاح"}</label>
            {mutation.isLoading ?<Spinner/> :    <label className="switch">
                  <input type="checkbox" onChange={(e)=>handleChangeStatus(e)}  checked={!is_closed}/>
                  <span className="slider round"></span>
                </label>}
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default StoreStatusCard